import React, { useRef, useState } from 'react';
import classes from "./Accordian.module.css";
import { FiPlus } from "react-icons/fi";
import { RxCross2 } from "react-icons/rx";

export default function Accordian({ title, children }) {
    const [open, setOpen] = useState(false);
    const contentRef = useRef(null);

    return (
        <div className={classes.accordian}>
            <p className={`f-19 fw-600 ${classes.title}`}>{title} <span className={classes.icon} onClick={() => setOpen(!open)}>{open===true ? <RxCross2 size={23}/> : <FiPlus size={23}/>}</span></p>
            <div className={classes.contentDiv} ref={contentRef} style={{maxHeight: open ? `${contentRef?.current?.scrollHeight}px` : "0px"}}>{children}</div>
        </div>
    )
};
        